//
// DataStateChangeEvent.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "@sas-dvr/ltjs-commons/events/PortableEvent";
import "../../controllers/results/ResultController";

var DataStateChangeEvent = createModule("BIRD::DataStateChangeEvent", ["commons::PortableEvent"], ClosetObject, [
    {
        DATACHANGE: 50008,
    },
    ,
    ,
    {
        resultController: 1,
    },
    {
        getStructureChanged: [2],
    },
    ,
    ,
]);
export default DataStateChangeEvent;
